module.exports = __webpack_public_path__ + "static/media/kakis2.a4f41898.png";